module.exports = __webpack_public_path__ + "static/img/want_business.7977431.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/logo/want_business.png
// module id = oAOc
// module chunks = 1